import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getStyleSheet"],
  _excluded2 = ["children", "getStyleSheet"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { mergeDeepRight } from 'ramda';
import { propTypes, overridableComponents } from './overridableComponents';
function hasOverrides(overrides, key) {
  return overrides && overrides[key];
}
function getOverridesSafe(overrides, key) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return hasOverrides(overrides, key) ? overrides[key](...args) : {};
  };
}
function getChildContextFromProps(props) {
  var {
      getStyleSheet
    } = props,
    overrides = _objectWithoutProperties(props, _excluded);
  var current = {};
  var _loop = function (currentKey) {
    current[currentKey] = function () {
      return mergeDeepRight(getStyleSheet && getOverridesSafe(getStyleSheet, currentKey)(...arguments), getOverridesSafe(overrides, currentKey)(...arguments));
    };
  };
  for (var currentKey of overridableComponents) {
    _loop(currentKey);
  }
  return {
    getStyleSheet: current
  };
}
export var StyleSheetOverridesContext = /*#__PURE__*/React.createContext(null);
export var StyleSheetOverridesConsumer = StyleSheetOverridesContext.Consumer;
export function useStyleSheetOverrides() {
  return React.useContext(StyleSheetOverridesContext);
}
class StyleSheetOverridesProvider extends React.PureComponent {
  getChildContext() {
    return getChildContextFromProps(this.props);
  }
  render() {
    var _this$props = this.props,
      {
        children,
        getStyleSheet: getStyleSheetProp
      } = _this$props,
      overrides = _objectWithoutProperties(_this$props, _excluded2);
    var {
      getStyleSheet
    } = getChildContextFromProps(_objectSpread({
      getStyleSheet: getStyleSheetProp
    }, overrides));
    return /*#__PURE__*/React.createElement(StyleSheetOverridesContext.Provider, {
      value: getStyleSheet
    }, children);
  }
}
StyleSheetOverridesProvider.displayName = 'StyleSheetOverridesProvider';
StyleSheetOverridesProvider.childContextTypes = {
  getStyleSheet: PropTypes.shape(propTypes)
};
export default StyleSheetOverridesProvider;
//# sourceMappingURL=index.js.map